import { ContentBlock, Stack } from 'braid-design-system';

import GroupsView from 'src/components/organisms/CommunityExploreGroups/GroupsView';
import { CommunityLayout } from 'src/components/templates/Layouts/CommunityLayout';
import { MetaTag } from 'src/modules/meta/MetaTag';
import { getMetaData } from 'src/modules/meta/meta';
import { ROUTER_PATHS } from 'src/paths';
import { useConfig } from 'src/provider/config';

export function CommunityExploreGroups() {
  const { language, countryCode, absoluteUrl } = useConfig();

  return (
    <CommunityLayout>
      <Stack space="xxlarge">
        <MetaTag
          {...getMetaData({
            page: ROUTER_PATHS.communityGroups,
            language,
            absoluteUrl,
            countryCode,
          })}
        />
        <ContentBlock>
          <GroupsView />
        </ContentBlock>
      </Stack>
    </CommunityLayout>
  );
}
